import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, Legend, CartesianGrid } from "recharts";

export default function HourlyVolume({ data = [] }) {
  const isDark = typeof window !== "undefined" &&
                 window.matchMedia &&
                 window.matchMedia("(prefers-color-scheme: dark)").matches;

  const COLORS = {
    grid: isDark ? "#2b2b2b" : "#e5e7eb",
    tick: isDark ? "#e5e7eb" : "#1f2937",
    answered: isDark ? "#22d3ee" : "#06b6d4",
    abandoned: isDark ? "#f59e0b" : "#f59e0b",
    tooltipBg: isDark ? "#1a1a1a" : "#ffffff",
    tooltipBorder: isDark ? "#333" : "#ddd",
  };

  const hours = Array.from({length:24}, (_,h)=>h);
  const agg = hours.map(h => {
    const rows = data.filter(r => Number(r.hour) === h);
    return {
      hour: h,
      answered: rows.reduce((s,x)=>s+(x.answered||0),0),
      abandoned: rows.reduce((s,x)=>s+(x.abandoned||0),0),
      total: rows.reduce((s,x)=>s+(x.total_incoming||0),0),
    };
  });

  return (
    <div style={{height:320}}>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={agg}>
          <CartesianGrid stroke={COLORS.grid} />
          <XAxis dataKey="hour" tick={{ fill: COLORS.tick }} />
          <YAxis tick={{ fill: COLORS.tick }} />
          <Tooltip contentStyle={{ background: COLORS.tooltipBg, border:`1px solid ${COLORS.tooltipBorder}`, color: COLORS.tick }}/>
          <Legend wrapperStyle={{ color: COLORS.tick }}/>
          <Bar dataKey="answered" fill={COLORS.answered} />
          <Bar dataKey="abandoned" fill={COLORS.abandoned} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
